/* Product info tabs v2 — assets/ezp-info-tabs.js
   <ezp-info-tabs> from snippets/ezp-info-tabs.liquid. Each instance wires its own
   tabs, so several on one page (or a theme-editor re-render) need nothing extra.
   Keyboard follows the WAI-ARIA tabs pattern: arrows, Home, End. */

if (!customElements.get('ezp-info-tabs')) {
  customElements.define(
    'ezp-info-tabs',
    class EzpInfoTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll(':scope > [role="tablist"] > [role="tab"]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab));
          tab.addEventListener('keydown', (e) => this.onKey(e, tab));
        });
      }

      select(tab, focus = false) {
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + CSS.escape(t.getAttribute('aria-controls')));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }

      onKey(e, tab) {
        const i = this.tabs.indexOf(tab);
        const last = this.tabs.length - 1;
        const next = { ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last }[e.key];
        if (next === undefined) return;
        e.preventDefault();
        this.select(this.tabs[next], true);
      }
    }
  );
}
